document.addEventListener("DOMContentLoaded", function() {
    let selectedOptions = {
      // Check for either 'Couleur' or 'Color', and assign the first found value
      Couleur: (document.querySelector('select[name="options[Couleur]"]') || document.querySelector('select[name="options[Color]"]')) 
        ? (document.querySelector('select[name="options[Couleur]"]') || document.querySelector('select[name="options[Color]"]')).value 
        : '',
      Fini: document.querySelector('select[name="options[Fini]"]') ? document.querySelector('select[name="options[Fini]"]').value : '',
      Dimensions: document.querySelector('select[name="options[Dimensions]"]') ? document.querySelector('select[name="options[Dimensions]"]').value : '',
      Essence: document.querySelector('select[name="options[Essence]"]') ? document.querySelector('select[name="options[Essence]"]').value : '',
      Format: document.querySelector('select[name="options[Format]"]') ? document.querySelector('select[name="options[Format]"]').value : '',
      Grade: document.querySelector('select[name="options[Grade]"]') ? document.querySelector('select[name="options[Grade]"]').value : '',
      Odeur: document.querySelector('select[name="options[Odeur]"]') ? document.querySelector('select[name="options[Odeur]"]').value : '',
      QuantitéRouleau: document.querySelector('select[name="options[Quantité/Rouleau]"]') ? document.querySelector('select[name="options[Quantité/Rouleau]"]').value : '',
      Texture: document.querySelector('select[name="options[Texture]"]') ? document.querySelector('select[name="options[Texture]"]').value : '',
      // Type: document.querySelector('select[name="options[Type]"]') ? document.querySelector('select[name="options[Type]"]').value : ''
    };
  
    // Function to update the selected options object and log changes
    function updateSelectedOptions() {
      // Check if the option exists before trying to get its value
      const couleurSelect = document.querySelector('select[name="options[Couleur]"]') || document.querySelector('select[name="options[Color]"]');
      const finiSelect = document.querySelector('select[name="options[Fini]"]');
      
      selectedOptions.Couleur = couleurSelect ? couleurSelect.value : '';
      selectedOptions.Fini = finiSelect ? finiSelect.value : '';
    }
  
    // Function to update the sample info text area (just with the selected options)
    function updateSampleInfoText() {
      var variantOptions = [];
      const englishPage = window.location.href.includes('/en/');
      if (!englishPage) {
        if (selectedOptions.Couleur) variantOptions.push(`Couleur: ${selectedOptions.Couleur}`);
        if (selectedOptions.Fini) variantOptions.push(`Fini: ${selectedOptions.Fini}`);
        if (selectedOptions.Dimensions) variantOptions.push(`Dimensions: ${selectedOptions.Dimensions}`);
        if (selectedOptions.Essence) variantOptions.push(`Essence: ${selectedOptions.Essence}`);
        if (selectedOptions.Format) variantOptions.push(`Format: ${selectedOptions.Format}`);
        if (selectedOptions.Grade) variantOptions.push(`Grade: ${selectedOptions.Grade}`);
        if (selectedOptions.Odeur) variantOptions.push(`Odeur: ${selectedOptions.Odeur}`);
        if (selectedOptions.QuantitéRouleau) variantOptions.push(`Quantité/Rouleau: ${selectedOptions.QuantitéRouleau}`);
        if (selectedOptions.Texture) variantOptions.push(`Texture: ${selectedOptions.Texture}`);
      } else {
        if (selectedOptions.Couleur) variantOptions.push(`Colour: ${selectedOptions.Couleur}`);
        if (selectedOptions.Fini) variantOptions.push(`Finish: ${selectedOptions.Fini}`);
        if (selectedOptions.Dimensions) variantOptions.push(`Dimensions: ${selectedOptions.Dimensions}`);
        if (selectedOptions.Essence) variantOptions.push(`Essence: ${selectedOptions.Essence}`);
        if (selectedOptions.Format) variantOptions.push(`Format: ${selectedOptions.Format}`);
        if (selectedOptions.Grade) variantOptions.push(`Grade: ${selectedOptions.Grade}`);
        if (selectedOptions.Odeur) variantOptions.push(`Odor: ${selectedOptions.Odeur}`);
        if (selectedOptions.QuantitéRouleau) variantOptions.push(`Quantity/Roll: ${selectedOptions.QuantitéRouleau}`);
        if (selectedOptions.Texture) variantOptions.push(`Texture: ${selectedOptions.Texture}`);
      }

      // if (selectedOptions.Type) variantOptions.push(`Type: ${selectedOptions.Type}`);
  
      const sampleVariantElement = document.getElementById("sample-variant");
      const samplePriceElement = document.getElementById("sample-price");
  
      // Update sample variant text dynamically
      if (sampleVariantElement) {
        sampleVariantElement.textContent = variantOptions.join(' | ') || 'Select a variant'; // Fallback text if no options selected
      }
  
      // Set the sample price to a static value (as specified)
      if (samplePriceElement) {
        samplePriceElement.textContent = "5.00";
      }
    }
  
    // Add event listeners to variant selectors (if available)
    var variantSelectors = document.querySelectorAll(".product-form__input select");
    variantSelectors.forEach(function(select) {
      select.addEventListener("change", function() {
        updateSelectedOptions();
        updateSampleInfoText();
      });
    });
  
    // Initial update when the page loads
    updateSampleInfoText();
  });
  